import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { scrollToPurchase } from '../utils/scrollToPurchase';
export function WhatIsSection() {
  const items = [{
    emoji: '📦',
    text: 'Estrategia para convertir clientes en recurrentes'
  }, {
    emoji: '📦',
    text: 'Método para estabilizar la agenda semanal'
  }, {
    emoji: '📦',
    text: 'Sistema para aumentar ingreso promedio por cliente (sin subir el valor del corte)'
  }, {
    emoji: '🎁',
    text: 'Protocolo Anticancelaciones'
  }, {
    emoji: '🎁',
    text: 'Plan de implementación en 14 días'
  }, {
    emoji: '🎁',
    text: 'Guía Anti-Finde'
  }];
  return <section className="mt-2 md:-mt-6 pb-3 md:pb-12 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-274">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="bg-zinc-900/50 border border-zinc-800 rounded-xl md:rounded-2xl p-3 md:p-8" data-id="element-275">
        <h2 className="text-lg md:text-2xl font-heading font-bold text-white mb-1 md:mb-2 uppercase flex items-center gap-2" data-id="element-276">
          <span className="text-amber-500" data-id="element-277">📦</span> ¿QUÉ ES ESTE PLAN?
        </h2>

        <p className="text-xs md:text-sm text-zinc-400 mb-2 md:mb-4" data-id="element-278">
          Este plan incluye:
        </p>

        <ul className="space-y-1 md:space-y-2 mb-3 md:mb-5" data-id="element-279">
          {items.map((item, index) => <motion.li key={index} initial={{
          opacity: 0,
          x: -12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.07
        }} className="flex items-center gap-2 md:gap-3" data-id="element-280">
              <span className="text-sm flex-shrink-0" data-id="element-281">{item.emoji}</span>
              <span className="text-xs md:text-sm text-zinc-200" data-id="element-282">
                {item.text}
              </span>
            </motion.li>)}
        </ul>

        <div className="bg-zinc-950 py-2 md:py-3 px-3 md:px-4 rounded-lg md:rounded-xl border border-zinc-800 text-center" data-id="element-283">
          <p className="text-sm md:text-lg font-heading font-bold text-amber-400 uppercase tracking-wide" data-id="element-284">
            Descargás. Aplicás. Llená martes y miércoles.
          </p>
        </div>
      </motion.div>

      {/* Orange CTA */}
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      delay: 0.2,
      duration: 0.4
    }} className="mt-3 md:mt-6" data-id="element-285">
        <motion.button whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.97
      }} onClick={scrollToPurchase} className="w-full py-3 md:py-4 rounded-xl bg-gradient-to-r from-orange-600 to-orange-500 hover:from-orange-500 hover:to-orange-400 text-white font-heading font-bold text-base md:text-lg uppercase tracking-wider shadow-[0_0_25px_rgba(234,88,12,0.35)] hover:shadow-[0_0_35px_rgba(234,88,12,0.5)] transition-all duration-300" data-id="element-286">
          QUIERO LLENAR MI SEMANA
        </motion.button>
      </motion.div>
    </section>;
}